export const SCROLL_OFFSET = 200;
export const BREAKPOINTS = {
  small: 640,
  medium: 960,
  large: 1200,
  xlarge: 1600
}
